if (typeof LevoCarrouselTestimonials !== 'function') {
    class LevoCarrouselTestimonials extends HTMLElement {
        constructor() {
            super();
            this.interval = 4000;
            this.carosuelHolder = this.querySelector('[data-testimonials-holder]');
            this.carosuelContent = this.querySelector('[data-testimonials-content]');
            this.slides = this.querySelectorAll('.logo-icon');
            this.totalSlides = this.slides.length;
            this.currentIndex = 0;
            this.widthItems;
            if(window.innerWidth > 768) {
                this.widthItems = 350;
            } else {
                this.widthItems = 160;
            }

            this.carosuelContent.style.width = `${this.totalSlides * this.widthItems}px`;
            this.initCarousel();
        }

        initCarousel() {
            this.startCarousel();
        }

        startCarousel() {
            this.carouselInterval = setInterval(() => {
                this.nextSlide();
            }, this.interval);
        }

        nextSlide() {
            this.currentIndex++;
            if(this.currentIndex > (this.totalSlides - 4)) {
                this.currentIndex = 1;
                this.carosuelContent.style.transform = 'translateX(0)';
            }else{
                this.carosuelContent.style.transform = `translateX(-${this.currentIndex * this.widthItems}px)`;
            }
        }


    }
    if (typeof customElements.get('levo-testimonials') == 'undefined') {
        customElements.define('levo-testimonials', LevoCarrouselTestimonials);
    }
}